/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Meta_TitleInputs */

const en_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps & Clinics | Mark Egly Golf`)
};

const es_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campamentos y clínicas | Mark Egly Golf`)
};

const de_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps & Kurse | Mark Egly Golf`)
};

const zh_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`训练营与训练班 | Mark Egly Golf`)
};

const ar_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعسكرات والورش التدريبية | Mark Egly Golf`)
};

const fr_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps et stages | Mark Egly Golf`)
};

const vi_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trại và lớp chuyên đề | Mark Egly Golf`)
};

const sw_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kambi na Mafunzo | Mark Egly Golf`)
};

const th_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แคมป์และคลินิกกอล์ฟ | Mark Egly Golf`)
};

const bs_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampovi i kursevi | Mark Egly Golf`)
};

const ja_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンプ&クリニック | Mark Egly Golf`)
};

const ko_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캠프 & 클리닉 | Mark Egly Golf`)
};

const pt_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acampamentos e clínicas | Mark Egly Golf`)
};

const it_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camp e clinic | Mark Egly Golf`)
};

const sv_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läger och kurser | Mark Egly Golf`)
};

const nl_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampen & clinics | Mark Egly Golf`)
};

const da_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps og kurser | Mark Egly Golf`)
};

const nb_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leirer og kurs | Mark Egly Golf`)
};

const fi_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leirit ja kurssit | Mark Egly Golf`)
};

const pl_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obozy i szkolenia | Mark Egly Golf`)
};

const ru_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лагеря и мастер-классы | Mark Egly Golf`)
};

const tr_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamplar ve Eğitim Programları | Mark Egly Golf`)
};

const hi_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैंप और प्रशिक्षण सत्र | Mark Egly Golf`)
};

const id_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamp & Kelas | Mark Egly Golf`)
};

const ms_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kem & Kelas | Mark Egly Golf`)
};

const cs_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kempy a kurzy | Mark Egly Golf`)
};

const el_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κατασκηνώσεις & σεμινάρια | Mark Egly Golf`)
};

const he_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחנות וסדנאות | Mark Egly Golf`)
};

const af_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampe en kursusse | Mark Egly Golf`)
};

const hu_events_meta_title = /** @type {(inputs: Events_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Táborok és tanfolyamok | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Camps & Clinics \| Mark Egly Golf" |
*
* @param {Events_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_meta_title = /** @type {((inputs?: Events_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_meta_title(inputs)
	if (locale === "de") return de_events_meta_title(inputs)
	if (locale === "zh") return zh_events_meta_title(inputs)
	if (locale === "ar") return ar_events_meta_title(inputs)
	if (locale === "fr") return fr_events_meta_title(inputs)
	if (locale === "vi") return vi_events_meta_title(inputs)
	if (locale === "sw") return sw_events_meta_title(inputs)
	if (locale === "th") return th_events_meta_title(inputs)
	if (locale === "bs") return bs_events_meta_title(inputs)
	if (locale === "ja") return ja_events_meta_title(inputs)
	if (locale === "ko") return ko_events_meta_title(inputs)
	if (locale === "pt") return pt_events_meta_title(inputs)
	if (locale === "it") return it_events_meta_title(inputs)
	if (locale === "sv") return sv_events_meta_title(inputs)
	if (locale === "nl") return nl_events_meta_title(inputs)
	if (locale === "da") return da_events_meta_title(inputs)
	if (locale === "nb") return nb_events_meta_title(inputs)
	if (locale === "fi") return fi_events_meta_title(inputs)
	if (locale === "pl") return pl_events_meta_title(inputs)
	if (locale === "ru") return ru_events_meta_title(inputs)
	if (locale === "tr") return tr_events_meta_title(inputs)
	if (locale === "hi") return hi_events_meta_title(inputs)
	if (locale === "id") return id_events_meta_title(inputs)
	if (locale === "ms") return ms_events_meta_title(inputs)
	if (locale === "cs") return cs_events_meta_title(inputs)
	if (locale === "el") return el_events_meta_title(inputs)
	if (locale === "he") return he_events_meta_title(inputs)
	if (locale === "af") return af_events_meta_title(inputs)
	if (locale === "hu") return hu_events_meta_title(inputs)
	return en_events_meta_title(inputs)
});